import ListProjectsAsList from 'viewmodel/ListProjectsAsListViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesListProjectsAsList extends DesBaseCollabAcc {

    constructor() {
        super(ListProjectsAsList);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id' ];
    }
}
if (!window.customElements.get('des-list-projects-as-list')) {
    window.customElements.define('des-list-projects-as-list', DesListProjectsAsList);
}
